
// This file serves as a compatibility layer to prevent breaking changes after refactoring
import Hey, { ImageFormat } from "./hey";

// Re-export the ImageFormat enum as a property on the default export
Hey.ImageFormat = ImageFormat;

export default Hey;
